import React, { useState } from "react"
import { Box } from "@mui/material"
import Categories from "./categories"
import NewestRecipes from "./newestRecipes"
import FilteredRecipes from "./filteredRecipes"
import PopularRecipes from "./popularRecipes"
import { CATEGORIES_WITH_ICONS as CATEGORIES } from "../constants"
// Sample categories data

const HomePage = () => {
  const [selectedCategory, setSelectedCategory] = useState("Featured")

  // Handle category selection
  const handleCategoryClick = (category) => {
    setSelectedCategory(category)
  }

  return (
    <Box>
      <Categories
        categories={CATEGORIES}
        onCategoryClick={handleCategoryClick}
      />

      {/* Conditionally render NewestRecipes or FilteredRecipes based on selectedCategory */}
      {selectedCategory !== "Featured" ? (
        <FilteredRecipes selectedCategory={selectedCategory} />
      ) : (
        <>
          <NewestRecipes />
          <PopularRecipes />
        </>
      )}
    </Box>
  )
}

export default HomePage
